import { motion } from "framer-motion";
import { MapPin, Search, Home, LayoutGrid, ShoppingBag, User, Star } from "lucide-react";

const shops = [
  { name: "Fashion Store", dist: "1.2 km", rating: "4.8", tint: "from-amber-500/30 to-amber-700/20" },
  { name: "Grocery Mart", dist: "2.1 km", rating: "4.7", tint: "from-emerald-500/30 to-emerald-700/20" },
  { name: "Mobile Hub", dist: "3.4 km", rating: "4.6", tint: "from-sky-500/30 to-sky-700/20" },
];

export const PhoneMockup = () => (
  <div className="relative animate-float" data-testid="hero-phone-mockup">
    <div className="absolute -inset-10 bg-amber-400/10 blur-3xl rounded-full animate-glow -z-10" />
    <div className="w-[290px] sm:w-[320px] rounded-[2.6rem] border border-white/15 bg-[#0f172a]/90 backdrop-blur-2xl shadow-[0_32px_80px_rgba(0,0,0,0.6),0_0_60px_rgba(251,191,36,0.08)] p-3">
      <div className="rounded-[2rem] bg-[#0b0f19] overflow-hidden">
        <div className="flex items-center justify-between px-5 pt-4">
          <span className="font-display text-sm font-semibold tracking-widest text-amber-400">GROMZA</span>
          <span className="text-[10px] text-slate-500">9:41</span>
        </div>
        <div className="px-5 pt-4">
          <p className="text-[15px] font-medium leading-snug">Discover Local Shops &amp; Products Near You</p>
          <div className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-amber-400/10 border border-amber-400/25 px-3 py-1 text-[10px] text-amber-300">
            <MapPin size={10} /> Within 3-5 KM
          </div>
        </div>
        <div className="mx-5 mt-4 flex items-center gap-2 rounded-xl bg-white/5 border border-white/10 px-3 py-2.5">
          <Search size={13} className="text-slate-500" />
          <span className="text-[11px] text-slate-500">Search products or shops...</span>
        </div>
        <div className="px-5 mt-4 flex items-center justify-between">
          <span className="text-[11px] font-semibold text-slate-300">Top Shops Near You</span>
          <span className="text-[10px] text-amber-400">See all</span>
        </div>
        <div className="px-5 mt-2.5 space-y-2.5 pb-4">
          {shops.map((s) => (
            <div key={s.name} className="flex items-center gap-3 rounded-xl bg-white/[0.04] border border-white/[0.06] p-2.5">
              <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${s.tint} border border-white/10`} />
              <div className="flex-1">
                <p className="text-[11px] font-medium">{s.name}</p>
                <p className="text-[9px] text-slate-500">{s.dist} away</p>
              </div>
              <span className="inline-flex items-center gap-1 text-[10px] text-amber-400">
                <Star size={9} fill="currentColor" /> {s.rating}
              </span>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-around border-t border-white/[0.06] py-3">
          <Home size={15} className="text-amber-400" />
          <LayoutGrid size={15} className="text-slate-600" />
          <ShoppingBag size={15} className="text-slate-600" />
          <User size={15} className="text-slate-600" />
        </div>
      </div>
    </div>
    <motion.div
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1, duration: 0.8 }}
      className="absolute -right-14 top-8 glass-panel rounded-2xl px-4 py-3 hidden xl:block"
    >
      <p className="text-[10px] uppercase tracking-widest text-slate-400">90 Din</p>
      <p className="font-display text-lg font-semibold gold-text">FREE TRIAL</p>
    </motion.div>
    <motion.div
      initial={{ opacity: 0, x: -24 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.2, duration: 0.8 }}
      className="absolute -left-16 bottom-16 glass-panel rounded-2xl px-4 py-3 hidden xl:block"
    >
      <p className="text-[10px] uppercase tracking-widest text-slate-400">Hyper-local</p>
      <p className="font-display text-lg font-semibold text-white">3-5 KM Reach</p>
    </motion.div>
  </div>
);
